(ns ui.view.esign.event
  (:require
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.global-events.toast :as toast]
   [common.localization :as loc]))

(rf/reg-event-fx
 ::send-reminder-to-signatory-success
 [rf/trim-v]
 (fn [_cofx [{:keys [signatory-email success-event] :as _args}]]
   (merge
    {::toast/success (loc/tr :reminder-successfully-sent-to- [signatory-email])}
    (when (vector? success-event)
      {:fx [[:dispatch success-event]]}))))

(rf/reg-event-fx
 ::send-reminder-to-signatory-error
 [rf/trim-v]
 (fn [_cofx [{:keys [signatory-email] :as _args} _resp]]
   {::toast/error (loc/tr :there-was-an-error-sending-reminder-to- [signatory-email])}))

(rf/reg-event-fx
 ::send-reminder-to-signatory
 [rf/trim-v]
 (fn [_cofx [{:keys [esign-process-id signatory-id] :as args}]]
   {::ws/send {:id :esign-v2/remind
               :body {:esign-process-id esign-process-id
                      :signatory-id signatory-id}
               :on-success [::send-reminder-to-signatory-success args]
               :on-error [::send-reminder-to-signatory-error args]}}))
